import { FormattedMessage } from 'react-intl';
import React from 'react';

import NavigationButtons from '../Navigation/NavigationButtons/';

const NoTopicPage = ({ classes }) => (
  <div className={classes.noTopicWrapper}>
    <p>
      <FormattedMessage id="journeyBuilder.noTopic" />
    </p>
    <NavigationButtons onlyCancel />
  </div>
);

NoTopicPage.displayName = 'NoTopicPage';

export default NoTopicPage;



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/components/NoTopicPage/NoTopicPage.js